/** @jsxImportSource @emotion/react */
import { Stack } from '@mui/material';
import React, { ReactElement } from 'react';
import AppHeader from 'src/components/AppHeader/AppHeader';
import { DEFAULT_SPACING } from 'src/theme/style-consts';

export function SingleColumnPageBase(props: {pageContent: ReactElement}) {

    return (
        <Stack sx={{ height: '100vh' }}>
            <AppHeader/>
            <Stack sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden', padding: DEFAULT_SPACING }}>
                {props.pageContent}
            </Stack>
        </Stack>
    )
}